import { transitionend } from "./transitionend";

export type ScrollToOptions = {
  scrollContainer?: HTMLElement,
  scrollElement?: HTMLElement,
  scrollPosition?: number,
  scrollDuration?: number,
  easing?: string,
  makeVisible?: boolean
};

export async function scrollTo(window: Window, scrollTarget?: HTMLElement, scrollDuration?: number);
export async function scrollTo(window: Window, scrollPosition?: number, scrollDuration?: number);
export async function scrollTo(scrollTarget: HTMLElement, scrollDuration?: number);
export async function scrollTo(scrollPosition?: number, scrollDuration?: number);
export async function scrollTo(options: ScrollToOptions);
export async function scrollTo(...args: any) {
  let i=0;
  let scrollElement: HTMLElement = (args[i] instanceof HTMLElement) ? args[i++] : undefined;
  let scrollPosition: number = (!scrollElement && typeof(args[i]) === 'number') ? args[i++] : undefined;
  let scrollDuration: number = (typeof(args[i]) === 'number') ? args[i++] : 500;
  let easing: string = (typeof(args[i]) === 'string') ? args[i++] : '';
  let options: ScrollToOptions | undefined = (typeof(args[i]) === 'object') ? args[i++] : undefined;

  if (options) {
    scrollElement = options.scrollElement;
    scrollPosition = options.scrollPosition;
    scrollDuration = options.scrollDuration;
    easing = options.easing;
  }

  // Find current scrollTop
  let scrollContainer: HTMLElement = options?.scrollContainer ?? window.document.body;
  let currentScrollTop: number;
  if (scrollContainer instanceof HTMLBodyElement) {
    let html = scrollContainer.ownerDocument.documentElement;
    let body = scrollContainer;
    currentScrollTop = html.scrollTop ?? body.scrollTop;
  }
  else if (scrollContainer instanceof HTMLHtmlElement) {
    let html = scrollContainer;
    let body = html.ownerDocument.body;
    currentScrollTop = html.scrollTop ?? body.scrollTop;
    scrollContainer = body;
  } else {
    currentScrollTop = scrollContainer.scrollTop;
  }

  // Calculate top offset of scrollTarget
  if (scrollElement) {
    scrollPosition = scrollElement.getBoundingClientRect().top + currentScrollTop;
  }

  // If nothing is given, scroll to top
  scrollPosition = scrollPosition ?? 0;

  // If item is in view, and no need to scroll
  if (options?.makeVisible) {
    let scrollContainerTop = currentScrollTop;
    let scrollContainerBottom = currentScrollTop + scrollContainer.clientHeight;
    let scrollElementTop = scrollPosition;
    let scrollElementBottom = scrollPosition;
    if (scrollElement) {
      scrollElementBottom += scrollElement.clientHeight;
    }
    if (scrollContainerTop < scrollElementTop && scrollContainerBottom > scrollElementBottom) {
      // Entire in view
      return;
    }
    // If element is below screen, make it fit at bottom
    // If element is above screen, make it fit at top
  }

  // Don't scroll more than possible
  scrollPosition = Math.min(scrollPosition, scrollContainer.scrollHeight - scrollContainer.clientHeight);
  scrollPosition = Math.max(scrollPosition, 0);

  // Calculate difference
  let scrollDiff = currentScrollTop - scrollPosition;
  if (!scrollDiff) {
    return;
  }

  // Cache previous css values
  let transitionCache = scrollContainer.style.transition;
  let transformCache = scrollContainer.style.transform;

  // Scroll using translate3d
  scrollContainer.style.transition = 'transform ' + scrollDuration + 'ms ' + easing;
  scrollContainer.style.transform = 'translate3d(0, ' + scrollDiff + 'px, 0)';
  await transitionend(scrollContainer, 'transform');

  // Revert
  scrollContainer.style.transition = transitionCache;
  scrollContainer.style.transform = transformCache;
  scrollContainer.scrollTop = scrollPosition;

  if (scrollContainer instanceof HTMLBodyElement) {
    scrollContainer.ownerDocument.documentElement.scrollTop = scrollPosition;
  }
}